var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewOverviewInitialBg2 = function SvgNewOverviewInitialBg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1949,
    height: 1174,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#new-overview-initial-bg-2_svg__a)",
    strokeWidth: 11,
    d: "M360.5 1170V661l166-83 27.5 27.5L776.5 383H1213l136.5-56.5L1945 922M681 471 508.55 302.751M857.662 389l.002 784.5M1183 388.5v785M1011.99 377V0M0 302.751h1007M1945 568.5H857.5M1436.5 0v1173"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "new-overview-initial-bg-2_svg__a",
    x1: 1450,
    x2: 70.5,
    y1: 563.195,
    y2: 550.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C4C4F",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3C4C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C4C4F",
    stopOpacity: 0
  })))));
};
export { SvgNewOverviewInitialBg2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk0OSIgaGVpZ2h0PSIxMTc0IiB2aWV3Qm94PSIwIDAgMTk0OSAxMTc0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMzYwLjUgMTE3MFY2NjFMNTI2LjUgNTc4TDU1NCA2MDUuNUw3NzYuNSAzODNIMTIxM0wxMzQ5LjUgMzI2LjVMMTk0NSA5MjJNNjgxIDQ3MUw1MDguNTUgMzAyLjc1MU04NTcuNjYyIDM4OUw4NTcuNjY0IDExNzMuNU0xMTgzIDM4OC41VjExNzMuNU0xMDExLjk5IDM3N1YwTTAgMzAyLjc1MUgxMDA3TTE5NDUgNTY4LjVIODU3LjVNMTQzNi41IDBWMTE3MyIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfMzI3OV80NzQ4KSIgc3Ryb2tlLXdpZHRoPSIxMSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzMyNzlfNDc0OCIgeDE9IjE0NTAiIHkxPSI1NjMuMTk1IiB4Mj0iNzAuNTAwMSIgeTI9IjU1MC43NSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjM0M0QzRGIiBzdG9wLW9wYWNpdHk9IjAuMjciLz4KPHN0b3Agb2Zmc2V0PSIwLjM2IiBzdG9wLWNvbG9yPSIjM0M0QzRGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzNDNEM0RiIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";